const {dbToCloud} = require("./lib/db-to-cloud");
const drive = require("./lib/drive");

module.exports = {dbToCloud, drive};
